import ScanQR from "../../assets/img/scan-qr.png";
import QrImg from "../../assets/img/qr_code_img.png";

const QrCode = ({ setActivePaymentMethod, activePaymentMethod }) => {
  const handleQrCode = () => {
    setActivePaymentMethod("qr");
  };

  return (
    <>
      <div className="payment-option" onClick={handleQrCode}>
        <span>
          <input
            type="radio"
            name="qrMethod"
            value="qr"
            checked={activePaymentMethod === "qr"}
            onChange={handleQrCode}
          />
          <img
            src={ScanQR}
            height={30}
            width={30}
            alt="ScanQR"
            style={{ marginRight: "12px", marginLeft: "12px" }}
          />
          Scan QR
        </span>
      </div>
      {activePaymentMethod === "qr" && (
        <center>
          <img src={QrImg} alt="QRCodeImg" height={350} />
          <p>Payment to QR will be confirmed within 3 working days</p>
        </center>
      )}
    </>
  );
};

export default QrCode;
